import { create } from 'zustand';

import { ZorDocument } from '@/types/zor.document.type';

export interface ZorDocumentState {
  zorDocuments: Array<ZorDocument> | undefined;
  setZorDocuments: (zorDocuments: Array<ZorDocument>) => void;
}

const useZorDocumentStore = create<ZorDocumentState>((set) => ({
  zorDocuments: undefined,
  setZorDocuments: (zorDocuments: Array<ZorDocument>) =>
    set(() => ({ zorDocuments })),
}));

export { useZorDocumentStore };
